// src/redux/slices/editControlSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EditControlState {
  isEditControl: boolean;
}

const initialState: EditControlState = {
  isEditControl: false,
};

export const editControlSlice = createSlice({
  name: 'editControl',
  initialState,
  reducers: {
    // Set edit control visibility
    setEditControl: (state, action: PayloadAction<boolean>) => {
      state.isEditControl = action.payload;
    },
  },
});

export const { setEditControl } = editControlSlice.actions;

export default editControlSlice.reducer;
